import { IOfferForMobileSiteSchema } from '../../repositories/search-engine/entities/offer/OfferForMobileSiteSchema';
import {
  fetchInfiniteSearchForMobileSite,
  TInfiniteSearchForMobileSiteRequest,
  TInfiniteSearchForMobileSiteResponse,
} from '../../repositories/search-engine/v1/infinite-search-for-mobile-site';
import { IApplicationContext } from '../../types/applicationContext';
import { ResponseError } from '../../utils/errors/ResponseError';

export async function fetchEmptyListingSuggestions(
  context: IApplicationContext,
  parameters: TInfiniteSearchForMobileSiteRequest,
): Promise<IOfferForMobileSiteSchema[]> {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode } = (await fetchInfiniteSearchForMobileSite({
      httpApi,
      parameters,
    })) as TInfiniteSearchForMobileSiteResponse;

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchEmptyListingSuggestions',
        message: response.message || 'Код ответа не 200',
        details: { errors: JSON.stringify(response.errors) },
      });
    }

    return response.offers ?? [];
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
